import {
  Tag,
  Box,
  Flex,
  Icon,
  Text,
  useColorModeValue,
  keyframes,
} from "@chakra-ui/react";
import { activeConnectorState } from "atoms/activeConnectorState";
import React, { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import {
  FaBolt,
  FaCheckCircle,
  FaClock,
  FaExclamationTriangle,
} from "react-icons/fa";
import styled from "@emotion/styled";

const StatusTag = styled(Tag)`
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  font-weight: 600;
  letter-spacing: 0.5px;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      45deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transform: translateX(-100%);
  }

  &:hover:before {
    transform: translateX(100%);
    transition: transform 0.75s ease;
  }
`;

const pulse = keyframes`
  0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(35, 169, 121, 0.7); }
  70% { transform: scale(1); box-shadow: 0 0 0 10px rgba(35, 169, 121, 0); }
  100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(35, 169, 121, 0); }
`;

const ConnectorStatusCard = () => {
  const activeConnector = useRecoilValue(activeConnectorState);
  const [status, setStatus] = useState(activeConnector?.Status);

  // Update status when activeConnector changes
  useEffect(() => {
    if (activeConnector) {
      setStatus(activeConnector.Status);
    }
  }, [activeConnector]);

  // Define status configurations
  // const statusConfig = {
  //   Charging: {
  //     icon: FaBolt,
  //     color: "brand.500",
  //     bgGradient: "linear-gradient(90deg, #23A979 0%, #ff9966 100%)",
  //     textColor: "#23A979",
  //   },
  //   Preparing: {
  //     icon: FaClock,
  //     color: "brand.500",
  //     bgGradient: "linear-gradient(90deg, #23A979 0%, #ff9966 100%)",
  //     textColor: "#23A979",
  //   },
  //   Available: {
  //     icon: FaCheckCircle,
  //     color: "green.500",
  //     bgGradient: "linear-gradient(90deg, #38A169 0%, #68D391 100%)",
  //     textColor: "green",
  //   },
  //   Unavailable: {
  //     icon: FaExclamationTriangle,
  //     color: "gray.600",
  //     bgGradient: "linear-gradient(90deg, #718096 0%, #A0AEC0 100%)",
  //     textColor: "black",
  //   },
  // };

  // Get current status config or default to Unavailable
  // const currentStatus = status || "Unavailable";
  // const config = statusConfig[currentStatus] || statusConfig.Unavailable;

  // Status configuration
  const getStatusConfig = () => {
    const currentStatus = activeConnector?.Status || status;
    switch (currentStatus) {
      case "Charging":
        return {
          color: "white",
          bg: "linear-gradient(135deg, #23A979 0%, #ff9966 100%)",
          animation: `${pulse} 2s infinite`,
        };
      case "Preparing":
        return {
          color: "white",
          bg: "linear-gradient(135deg, #f5a623 0%, #f7b955 100%)",
        };
      case "Available":
        return {
          color: "white",
          bg: "linear-gradient(135deg, #48BB78 0%, #68D391 100%)",
        };
      default:
        return {
          color: "white",
          bg: "linear-gradient(135deg, #718096 0%, #A0AEC0 100%)",
        };
    }
  };

  const statusConfig = getStatusConfig();

  return (
    <StatusTag
      size="lg"
      borderRadius="md"
      position="absolute"
      left={0}
      top={0}
      py={2}
      px={4}
      bg={statusConfig.bg}
      color={statusConfig.color}
      animation={statusConfig.animation}
      boxShadow="0 4px 12px rgba(0, 0, 0, 0.1)"
      mt={2}
      maxW="90%"
      textAlign="center"
      whiteSpace="nowrap"
      overflow="hidden"
      textOverflow="ellipsis"
      key={activeConnector?.Status || status} // Force re-render when status changes
    >
      {activeConnector?.Status || status}
    </StatusTag>
  );
};

export default ConnectorStatusCard;
